/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BorrowerOperations,
  BorrowerOperationsInterface,
} from "../BorrowerOperations";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address",
      },
    ],
    name: "CollSurplusPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address",
      },
    ],
    name: "GasPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
    ],
    name: "SortedTrovesAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_stabilityPoolAddress",
        type: "address",
      },
    ],
    name: "StabilityPoolAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "arrayIndex",
        type: "uint256",
      },
    ],
    name: "TroveCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_newTroveManagerAddress",
        type: "address",
      },
    ],
    name: "TroveManagerAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_coll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stake",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum BorrowerOperations.BorrowerOperation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "TroveUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_VSTAStakingAddress",
        type: "address",
      },
    ],
    name: "VSTAStakingAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_VSTFee",
        type: "uint256",
      },
    ],
    name: "VSTBorrowingFeePaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
    ],
    name: "VSTTokenAddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAddress",
        type: "address",
      },
    ],
    name: "VaultParametersBaseChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "DECIMAL_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_REF_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VSTAStaking",
    outputs: [
      {
        internalType: "contract IVSTAStaking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VSTAStakingAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VSTToken",
    outputs: [
      {
        internalType: "contract IVSTToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_assetSent",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "addColl",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_assetSent",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_collWithdrawal",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_VSTChange",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isDebtIncrease",
        type: "bool",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "adjustTrove",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "claimCollateral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
    ],
    name: "claimCollaterals",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "closeTrove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
    ],
    name: "getCompositeDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemColl",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemColl",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getEntireSystemDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "entireSystemDebt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountMoved",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_borrower",
        type: "address",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "moveETHGainToTrove",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_VSTAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "openTrove",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_VSTAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "repayVST",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stabilityPoolManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gasPoolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collSurplusPoolAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_VSTAStakingAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vestaParamsAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vaultParams",
        type: "address",
      },
    ],
    name: "setVestaParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sortedTroves",
    outputs: [
      {
        internalType: "contract ISortedTroves",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "troveManager",
    outputs: [
      {
        internalType: "contract ITroveManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestaParams",
    outputs: [
      {
        internalType: "contract IVestaParameters",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "bytes16",
            name: "traderSelector",
            type: "bytes16",
          },
          {
            internalType: "address[2]",
            name: "tokenInOut",
            type: "address[2]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct IVestaDexTrader.ManualExchange[]",
        name: "_manualExchange",
        type: "tuple[]",
      },
    ],
    name: "closeTroveWithDexTrader",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_collWithdrawal",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "withdrawColl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxFeePercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_VSTAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_upperHint",
        type: "address",
      },
      {
        internalType: "address",
        name: "_lowerHint",
        type: "address",
      },
    ],
    name: "withdrawVST",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type BorrowerOperationsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BorrowerOperationsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BorrowerOperations__factory extends ContractFactory {
  constructor(...args: BorrowerOperationsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<BorrowerOperations> {
    return super.deploy(overrides || {}) as Promise<BorrowerOperations>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): BorrowerOperations {
    return super.attach(address) as BorrowerOperations;
  }
  override connect(signer: Signer): BorrowerOperations__factory {
    return super.connect(signer) as BorrowerOperations__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BorrowerOperationsInterface {
    return new utils.Interface(_abi) as BorrowerOperationsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BorrowerOperations {
    return new Contract(address, _abi, signerOrProvider) as BorrowerOperations;
  }
}
